import * as net from './net'

export const load = () =>
  net.update('/api/basic_info')
